module.exports = __webpack_public_path__ + "static/media/notes-of-love-three.81499af0.png";